<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article class="main" *ngIf="stage === 1">
    <header>
      <h2 class="nomargin">Where are your properties listed?</h2>
    </header>
    <section class="content">
      <p>
        We might not necessarily support all channels you are working with just yet. Let’s see if we are a good fit for
        you.
      </p>
      <mat-checkbox (change)="toggleChannel('airbnb')" [checked]="channels.airbnb" [disabled]="isAirbnbSignup">
        Airbnb
      </mat-checkbox>

      <mat-checkbox (change)="toggleChannel('vrbo')" [checked]="channels.vrbo">Vrbo</mat-checkbox>

      <mat-checkbox (change)="toggleChannel('booking_com')" [checked]="channels.booking_com">Booking.com</mat-checkbox>

      <mat-checkbox (change)="toggleChannel('direct_booking')" [checked]="channels.direct_booking">
        Direct booking website
      </mat-checkbox>

      <mat-checkbox (change)="toggleChannel('tripadvisor')" [checked]="channels.tripadvisor">Tripadvisor</mat-checkbox>

      <mat-checkbox (change)="toggleChannel('agoda')" [checked]="channels.agoda">Agoda</mat-checkbox>

      <mat-checkbox (change)="toggleChannel('not_listed')" [checked]="channels.not_listed">
        I'm not listed yet!
      </mat-checkbox>

      <button
        mat-flat-button
        mat-primary
        class="next-step"
        [disabled]="!atLeastOneChannelEnabled || saving"
        (click)="next()">
        <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="30"></mat-spinner>
        Continue
      </button>
    </section>
  </article>

  <aside *ngIf="stage === 1">
    <div
      [ngClass]="{
        'channel-airbnb': true,
        'channel-active': !!channels.airbnb
      }">
      <div class="planet">
        <div class="inner-planet" fxLayoutAlign="center center">
          <img *ngIf="channels.airbnb" src="/assets/iconography/airbnb-white.svg" />
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'channel-vrbo': true,
        'channel-active': !!channels.vrbo
      }">
      <div class="planet">
        <div class="inner-planet" fxLayoutAlign="center center">
          <img *ngIf="channels.vrbo" src="/assets/iconography/homeaway-white.svg" />
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'channel-booking': true,
        'channel-active': !!channels.booking_com
      }">
      <div class="planet">
        <div class="inner-planet" fxLayoutAlign="center center">
          <img *ngIf="channels.booking_com" src="/assets/iconography/booking.svg" />
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'channel-tripadvisor': true,
        'channel-active': !!channels.tripadvisor
      }">
      <div class="planet">
        <div class="inner-planet" fxLayoutAlign="center center">
          <img *ngIf="channels.tripadvisor" src="/assets/iconography/tripadvisor.svg" />
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'channel-agoda': true,
        'channel-active': !!channels.agoda
      }">
      <div class="planet">
        <div class="inner-planet" fxLayoutAlign="center center">
          <img *ngIf="channels.agoda" src="/assets/iconography/agoda.svg" />
        </div>
      </div>
    </div>

    <img id="sun" [src]="wizard.signupUser?.avatar" onerror="this.src='/assets/images/signup/avatar.svg'" />
  </aside>

  <article class="main" *ngIf="stage === 2">
    <header>
      <h2 class="nomargin">Just a heads up...</h2>
    </header>

    <section class="content" fxLayout="column" fxLayoutGap="20px">
      <p>
        <ng-container *ngIf="selectedDirect && !selectedAgoda && !selectedTripAdvisor">
          While we can help you build your direct booking website, we do require you to connect an account with a
          supported channel to get started with Hospitable.com

          <br />
          <br />
        </ng-container>

        <ng-container *ngIf="selectedAgoda || selectedTripAdvisor">
          Thanks for registering your interest in
          <strong *ngIf="selectedAgoda">Agoda</strong>
          <ng-container *ngIf="selectedMultipleUnsupported">&</ng-container>
          <strong *ngIf="selectedTripAdvisor">Tripadvisor</strong>
          .

          <ng-container *ngIf="selectedMultipleUnsupported">
            We don't support these yet. You'll be the first to know when they become available.
          </ng-container>
          <ng-container *ngIf="!selectedMultipleUnsupported">
            We don't support this yet. You'll be the first to know when this becomes available.
          </ng-container>

          <br />
          <br />
        </ng-container>

        <em>We're a match!</em>
        ✨ We can support you on these awesome channels today:
      </p>

      <div fxLayout="column" fxLayoutGap="16px">
        <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img src="/assets/images/signup/unsupported-channels/airbnb.svg" alt="Airbnb" />
          <span fxFlex="0 0 126px" class="text__medium grape-darker">Airbnb</span>
          <span class="grass-darker text__medium">👌 Supported</span>
        </div>

        <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img src="/assets/images/signup/unsupported-channels/vrbo.svg" alt="Airbnb" />
          <span fxFlex="0 0 126px" class="text__medium grape-darker">Vrbo</span>
          <span class="grass-darker text__medium">👌 Supported</span>
        </div>

        <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img src="/assets/images/signup/unsupported-channels/booking.svg" alt="Airbnb" />
          <span fxFlex="0 0 126px" class="text__medium grape-darker">Booking.com</span>
          <span class="grass-darker text__medium">👌 Supported</span>
        </div>

        <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img src="/assets/images/signup/unsupported-channels/direct.svg" alt="Airbnb" />
          <span fxFlex="0 0 126px" class="text__medium grape-darker">Direct bookings</span>
          <span class="grass-darker text__medium">👌 Supported</span>
        </div>

        <!-- <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img
            src="/assets/images/signup/unsupported-channels/agoda.svg"
            alt="Airbnb"
          />
          <span fxFlex="0 0 126px" class="text__medium grape-darker"
            >Agoda</span
          >
          <span>⏳ Coming late 2021</span>
        </div>

        <div fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
          <img
            src="/assets/images/signup/unsupported-channels/tripadvisor.svg"
            alt="Airbnb"
          />
          <span fxFlex="0 0 126px" class="text__medium grape-darker"
            >Tripadvisor</span
          >
          <span>⏳ Coming late 2021</span>
        </div> -->
      </div>

      <button mat-flat-button mat-primary class="next-step unsupported-next-step" (click)="this.wizard.next()">
        Continue
      </button>
    </section>
  </article>

  <aside *ngIf="stage === 2">
    <img src="/assets/images/signup/channels-unsupported.svg" />
  </aside>

  <article class="main" *ngIf="stage === 3">
    <header>
      <h2 class="nomargin">We’re not ready for you yet</h2>
    </header>

    <section class="content" fxLayout="column" fxLayoutGap="32px">
      <p>
        We are currently integrated with
        <strong>Airbnb</strong>
        ,
        <strong>Vrbo</strong>
        ,
        <strong>Booking.com</strong>
        and
        <strong>Direct bookings</strong>
        . You'll be the first to know when additional channels become available.
      </p>

      <div>
        <a style="display: block; width: 100%" href="https://hospitable.com">
          <button mat-flat-button mat-primary class="next-step unsupported-next-step fw">
            Thanks! Keep me updated
          </button>
        </a>

        <sbnb-button label="Change selection" [fullWidth]="true" type="secondary" (clicked)="stage = 1"></sbnb-button>
      </div>
    </section>
  </article>

  <aside *ngIf="stage === 3">
    <img src="/assets/images/signup/channels-no-supported.svg" />
  </aside>
</section>
